export default __webpack_public_path__ + "static/designer-hierarchy-758960e69c0439910388c4f44f17e7a9.png";